import { useResizeObserver } from '@vueuse/core';
import { type Ref, ref } from 'vue';

export function useIsTruncated(elementRef: Ref<HTMLElement | null>) {
  const isTruncated = ref(false);

  function checkTruncation() {
    const element = elementRef.value;
    if (!element) return;
    isTruncated.value = element.scrollWidth > element.clientWidth;
  }

  useResizeObserver(elementRef, checkTruncation);

  return { isTruncated, checkTruncation };
}
